import i18n from '@speechki-frontend/core/i18n/i18n';
import {
    UnavailablePage,
    FaqPage,
    ContactsPage,
    StaticPage,
    PhonemesPage,
    NotFoundPage,
    ErrorPage,
} from './views';

let routes = [
    {
        path: '/unavailable',
        name: 'unavailable',
        component: UnavailablePage,
        meta: {
            guest: true,
            title: i18n.global.t('routes.unavailable'),
        },
    },
    {
        path: '/faq',
        name: 'faq',
        component: FaqPage,
        meta: {
            guest: true,
            title: 'FAQ  — Speechki',
        },
    },
    {
        path: '/contacts',
        name: 'contacts',
        component: ContactsPage,
        meta: {
            guest: true,
            title: i18n.global.t('routes.contacts'),
        },
    },
    {
        path: '/docs/:slug',
        name: 'static',
        component: StaticPage,
        meta: {
            guest: true,
        },
    },
    {
        path: '/phonemes',
        name: 'phonemes',
        component: PhonemesPage,
        meta: {
            title: 'Фонемы',
        },
    },
];

export const ErrorRoutes = [
    {
        path: '/error',
        name: 'error',
        component: ErrorPage,
        props: true,
        meta: {
            guest: true,
            title: 'Error',
        },
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        component: NotFoundPage,
        meta: {
            guest: true,
            title: 'Oops! Page not found',
        },
    },
];

export const maintenanceRoutes = [
    {
        path: '/:pathMatch(.*)*',
        name: 'unavailable',
        component: UnavailablePage,
        meta: {
            guest: true,
            title: i18n.global.t('routes.unavailable'),
        },
    },
];

export default routes;
